import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { mergeLandingSearch } from '../utils/preserveParams';
import { primeUserIP } from '../utils/userIp';

/**
 * Keeps the visitor's arrival query string on every URL they move to.
 *
 * Doing this centrally rather than at each `navigate` / `Link` call site means
 * a new link can't silently drop campaign attribution, and it also covers
 * links inside content and the browser back button.
 *
 * It re-writes the URL with `replace`, so no extra history entry is created and
 * Back still behaves normally. It is a no-op once the params are already there,
 * which is what stops it looping.
 */
export function QueryParamCarrier() {
  const location = useLocation();
  const navigate = useNavigate();

  // Resolved on arrival so it is already in hand when the first call fires.
  useEffect(() => {
    primeUserIP();
  }, []);
  useEffect(() => {
    const merged = mergeLandingSearch(location.search);
    if (merged === location.search) return;
    navigate(`${location.pathname}${merged}${location.hash}`, {
      replace: true,
      state: location.state
    });
    // location.state is intentionally excluded: funnel pages pass form data
    // through it and re-running on a state change would be redundant.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, location.search, location.hash, navigate]);
  return null;
}